import { api, endpoint } from "@/api";
import SplineChart from "@/components/Charts/SplineChart";
import { DatePicker } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import React, { memo, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import LoadingOverlay from "@/components/Shared/LoadingOverlay";

const { RangePicker } = DatePicker;

const AlarmGraph = memo(({ data }) => {
  const { site, device, business, parameter, critical, warning, min, interval = "1" } = data;

  const [graphData, setGraphData] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [stripLines, setStripLines] = useState([]);

  useEffect(() => {
    const body = {
      devices: [
        {
          business: [business],
          device,
          parameters: parameter,
          site,
        },
      ],
      // interval: (interval || 1).toString(),
      // operator: option || "min",
      from: from || moment().startOf("day").format("YYYY-MM-DD hh:mm"),
      to: to || moment().endOf("day").format("YYYY-MM-DD hh:mm"),
    };
    if (parameter) {
      setIsLoading(true);
      api
        .post(endpoint.device_comparison, body, {
          params: { limit: 10, page: 1, type: "graph" },
        })
        .then((res) => {
          setGraphData(res);
          setIsLoading(false);
        })
        .catch(() => setIsLoading(false));
    }
  }, [parameter, to, from]);

  useEffect(() => {
    if (min) {
      setStripLines([
        {
          value: min,
          color: "#ffc107",
          labelFontColor: "#ffc107",
          label: "Warning Level",
          thickness: 5,
        },
      ]);
    }
  }, [min]);
  return (
    <div className="mt-4">
      <p className="form-label">
        Live preview
        <span className="text-danger" style={{ fontFamily: "monospace", marginLeft: 3 }}>
          *
        </span>
      </p>
      <Row className="align-items-center">
        <Col md={6}>
          <RangePicker
            presets={{ label: "date" }}
            className="w-100"
            format="YYYY-MM-DD"
            onChange={(e, dateString) => {
              setFrom(dateString[0]);
              setTo(dateString[1]);
            }}
            disabledDate={(current) => current && current > moment().endOf("day")}
          />
        </Col>
        <Col md={6}>
          <div className="text-danger">Default time range is last 24 hours from current view</div>
        </Col>
      </Row>
      <LoadingOverlay isLoading={isLoading}>
        <div className="my-5" style={{ height: 350 }}>
          <SplineChart
            title=""
            data={graphData}
            from={from}
            to={to}
            isLoading={isLoading}
            interval={interval}
            critical={critical}
            warning={warning}
            stripLines={stripLines}
          />
        </div>
      </LoadingOverlay>
    </div>
  );
});

export default AlarmGraph;

AlarmGraph.displayName = "AlarmGraph";

AlarmGraph.propTypes = {
  data: PropTypes.object.isRequired,
};
